// src/App.js
import React, { useEffect } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { connect } from "react-redux";
import { auth } from "./firebase";
import { setUser, clearUser } from "./store/Auth/userActions";
import AppRoutes from "./routes";

const App = (props) => {
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) props.setUser(user);
      else props.clearUser();
    });
    return () => unsubscribe();
  }, [props]);

  return (
    <Router>
      <AppRoutes />
    </Router>
  );
};

export default connect(null, { setUser, clearUser })(App);
